import styled from '@styled';
import { tabletPortrait } from '../global.styles';

interface StyledDivProps {
  backgroundColor?: string;
  width?: string;
  height?: string;
  maxWidth?: string;
  textAlign?: string;
  margin?: string;
  padding?: string;
  mobilePadding?: string;
  mobileMargin?: string;
  backgroundImage?: string;
  borderRadius?: string;
  border?: string;
  display?: string;
  position?: string;
  mobileMaxWidth?: string;
  mobileDisplay?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  boxShadow?: string;
  mobilePosition?: string;
  gap?: string;
}
export const StyledDiv = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    ![
      'backgroundColor',
      'maxWidth',
      'textAlign',
      'mobilePadding',
      'mobileMargin',
      'backgroundImage',
      'borderRadius',
      'mobileMaxWidth',
      'mobileDisplay',
      'mobileWidth',
      'mobileHeight',
      'boxShadow',
      'mobilePosition',
    ].includes(prop),
})<StyledDivProps>`
  background: ${(props) => props.backgroundColor || 'transparent'};
  width: ${(props) => props.width || 'initial'};
  display: ${(props) => props.display || 'block'};
  height: ${(props) => props.height || 'initial'};
  border: ${(props) => props.border || 'none'};
  max-width: ${(props) => props.maxWidth || '100%'};
  text-align: ${(props) => props.textAlign || 'start'};
  margin: ${(props) => props['data-margin'] || '0'};
  padding: ${(props) => props.padding || '0'};
  ${(props) => props.backgroundImage && `background-image: url(${props.backgroundImage});  background-size: cover;`}
  border-radius: ${(props) => props.borderRadius || '0'};
  position: ${(props) => props.position || 'static'};
  box-shadow: ${(props) => props.boxShadow || 'none'};
  gap: ${(props) => props.gap || undefined};

  ${tabletPortrait} {
    padding: ${(props) => props.mobilePadding || props.padding || '0'};
    margin: ${(props) => props.mobileMargin || props['data-margin'] || '0'};
    max-width: ${(props) => props.mobileMaxWidth || props.maxWidth || '100%'};
    width: ${(props) => props.mobileWidth || props.width || '100%'};
    height: ${(props) => props.mobileHeight || props.height || 'fit-content'};
    position: ${(props) => props.mobilePosition || props.position || 'static'};
    display: ${(props) => props.mobileDisplay || props.display || 'block'};
  }
`;
